import React, { useState, useEffect } from 'react';
import { Loading, Modal } from '../../common';
import DeclaracionesJuradasPendientesGrid from '../DeclaracionesJuradasPendientesGrid';
import { ServerRequest } from '../../../utils/apiweb';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from '../../../config/apis';

const DeclaracionesJuradasPendientesModal = (props) => {

    const [pendientes, setPendientes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props.idCuenta > 0) FindPendientes(props.idCuenta);
    }, [props.idCuenta]);

    function FindPendientes(idCuenta) {
        setLoading(true);

        const paramsUrl = `/pendientes/cuenta/${idCuenta}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.MODELO_DECLARACION_JURADA,
            paramsUrl,
            null,
            callbackSuccessPendientes,
            callbackNoSuccess,
            callbackError
        );
    }

    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error.message);
            setLoading(false);
        })
        .catch((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
            setLoading(false);
        });
    }

    const callbackError = (error) => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando solicitud: ' + error.message);
        setLoading(false);
    }

    const callbackSuccessPendientes = (response) => {
        response.json()
        .then((data) => {
            setPendientes(data);
            setLoading(false);
        })
        .catch((error) => {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, 'Error procesando respuesta: ' + error);
            setLoading(false);
        });
    }

    return (
        <>
            <Loading visible={loading}></Loading>

            <Modal
                size="xl"
                title={`Períodos de DDJJ a presentar de la cuenta ${props.numeroCuenta}`}
                onEscape={() => props.onDismiss()}
                body={(
                    <DeclaracionesJuradasPendientesGrid
                        data={{
                            list: pendientes
                        }}
                    />
                )}
                footer={(
                    <button className="btn back-button" data-dismiss="modal" onClick={(event) => props.onDismiss()}>Volver</button>
                )}
                footerClassName="f-align"
            />
        </>
    )
}

export default DeclaracionesJuradasPendientesModal
